const URL = {
    NO_PHOTO: '/images/widget/showroom/asset/non-photo.png',
};

export default URL;
